export class Availabilityfull {
    id: any;
    cognome: any;
    nome: any;
    idanagrafica: any;
    availabilityfull: any;
}
